export const onboardingRouteNames = [
  'employeeLanding', 'getStarted',
  'onboardingExamplesStart', 'onboardingExample', 'onboardingComplete',
  'onboardingGeneralInfo', 'onboardingCauses', 'onboardingPrivacy',
  'onboardingCompanyDoesNotExistPage',
]
